import { Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { JButton, JTypography } from '../../../components'

interface DeleteLocationProps {
    is_open: boolean
    on_close: any
    area: any
    on_cancel: any
    on_toggle: any
    is_loading: boolean
}

const DeleteLocation = (props: DeleteLocationProps) => {
    const { t } = useTranslation()
    const { 
        is_open, 
        on_close, 
        area, 
        on_cancel, 
        on_toggle,
        is_loading,
    } = props

    return (
        <Modal isOpen={is_open} onClose={on_close}>
            <ModalOverlay />
            <ModalContent
                backgroundColor={'surfacePlus1'}
                padding={'24px'}
            >
                <ModalHeader></ModalHeader>
                <ModalCloseButton
                    top={'24px'}
                    right={'24px'}
                />
                <ModalBody
                    as={Flex}
                    flexDirection={'column'}
                    gap={'16px'}
                    padding={'0px'}
                    marginTop={'24px'}
                >
                    <JTypography size={'title-medium'}>
                        {t('pengaturan_absen_modal_hapus_lokasi_absen_area_judul', { label: area?.label })}
                    </JTypography>
                    <JTypography size={'body-medium'}>
                        {t('pengaturan_absen_modal_hapus_lokasi_absen_area_subjudul')}
                    </JTypography>
                </ModalBody>
                <ModalFooter
                    gap={'33px'}
                    padding={'0px'}
                    marginTop={'24px'}
                >
                    <JButton
                        size={'normal'}
                        variant={'j-outline'}
                        onClick={on_cancel}
                    >
                        {t('pengaturan_absen_modal_batal')}
                    </JButton>
                    <JButton
                        size={'normal'}
                        variant={'j-primary'}
                        onClick={on_toggle}
                        isLoading={is_loading}
                    >
                        {t('pengaturan_absen_hapus')}
                    </JButton>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default DeleteLocation